/*eslint-disable */
import _ from "lodash";

export function getBrands(state) {
    return  _.sortBy(_.uniq(state.items), (item) => {
        return item;
    });
}

